/**
 * X-ray software has no backend category: these are rows of the one software
 * list, split out on the client and saved back into the same list.
 */
const XRAY_SOFTWARES = ['Dexis', 'Gendex', 'Sidexis'] as const;

const XRAY_KEYS = new Set(XRAY_SOFTWARES.map((name) => name.toLowerCase()));

const isXraySoftware = (name: string): boolean => XRAY_KEYS.has(name.trim().toLowerCase());

/** Splits one software list into the general and X-ray parts, keeping each name's own spelling. */
export const splitXraySoftware = (
  list: readonly string[],
): { software: string[]; xray: string[] } => ({
  software: list.filter((name) => !isXraySoftware(name)),
  xray: list.filter(isXraySoftware),
});

/** The single list the API stores: both parts, deduplicated and sorted as the legacy card saved it. */
export const mergeXraySoftware = (software: readonly string[], xray: readonly string[]): string[] =>
  Array.from(new Set([...software, ...xray])).sort();
